import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/shared/data/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {
  projectCategories: any[] = [];
  isCategoryExpanded: boolean = false;
   

  constructor(
    private http: HttpClient,
    private data: DataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getProjectCategories();
  }

  getProjectCategories(): void {
    this.http.post<any>(this.data.base_url + 'get_project_categories/', {}).subscribe({
      next: (response) => {
        if (response.status == 1) {
          const categories = response.data
            .filter((item: any) => item.status == 1)
            .map((item: any) => ({
              id: item.id,
              name: item.category_name,
              image: item.category_image ? this.data.base_url + item.category_image.substring(1) : null,
              icon: 'bx bxs-food-menu',
              active: false
            }));

          this.projectCategories = categories;
        }
      },
      error: (err) => console.error('Categories error:', err)
    });
  }

  toggleCategoryExpand() {
    this.isCategoryExpanded = !this.isCategoryExpanded;
  }

  navigateToCategory(categoryId: string) {
    this.router.navigate(['/product-menu'], { queryParams: { category: categoryId } });
  }
}
